"use client";

import { useTranslations } from "next-intl";

interface BenefitsCardProps {
  photowall?: boolean;
}

export default function BenefitsCard({ photowall }: BenefitsCardProps) {
  const t = useTranslations("Index");
  const tPhotowall = useTranslations("landingPages.Photowall.6point");

  const textSettings = {
    pstrong: (children: any) => <p className="font-bold">{children}</p>,
    p: (children: any) => <p>{children}</p>,
    h2: (children: any) => <h2 className="font-bold text-lg">{children}</h2>,
  };

  if (photowall) {
    return (
      <div className="w-full max-w-screen-lg lg:mx-auto place-items-center grid gap-10 md:gap-20 items-center p-4 md:p-0">
        <h2 className="font-semibold text-4xl">{tPhotowall("title")}</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-4">
          <div className="grid gap-10 md:gap-20">
            <div className="flex gap-2">
              <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
              <div className="flex flex-col gap-2">
                {tPhotowall.rich("point1", textSettings)}
              </div>
            </div>
            <div className="flex gap-2">
              <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
              <div className="flex flex-col gap-2">
                {tPhotowall.rich("point2", textSettings)}
              </div>
            </div>
            <div className="flex gap-2">
              <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
              <div className="flex flex-col gap-2">
                {tPhotowall.rich("point3", textSettings)}
              </div>
            </div>
          </div>
          <div className="w-full rounded-[2.6rem] flex justify-center content-center overflow-hidden max-w-[275px] mx-auto md:mx-0">
            <video
              autoPlay
              muted
              loop
              playsInline
              className="max-h-[600px] md:max-h-[600px] rounded"
            >
              <source
                src="https://github.com/SKCarlsson/filestorage/raw/refs/heads/main/guestgallery/landing_frame.webm"
                type="video/webm"
              />
              {t("Section2.videoError")}
            </video>
          </div>
          <div className="grid gap-10 md:gap-20">
            <div className="flex gap-2">
              <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
              <div className="flex flex-col gap-2">
                {tPhotowall.rich("point4", textSettings)}
              </div>
            </div>
            <div className="flex gap-2">
              <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
              <div className="flex flex-col gap-2">
                {tPhotowall.rich("point5", textSettings)}
              </div>
            </div>
            <div className="flex gap-2">
              <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
              <div className="flex flex-col gap-2">
                {tPhotowall.rich("point6", textSettings)}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full max-w-screen-lg lg:mx-auto place-items-center grid gap-10 md:gap-20 items-center p-4 md:p-0">
      <h2 className="font-semibold text-4xl">{t("6point.title")}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-4">
        <div className="grid gap-10 md:gap-20">
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
            <div className="flex flex-col gap-2">
              {t.rich("6point.point1", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
            <div className="flex flex-col gap-2">
              {t.rich("6point.point2", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
            <div className="flex flex-col gap-2">
              {t.rich("6point.point3", textSettings)}
            </div>
          </div>
        </div>
        <div className="w-full rounded-[2.6rem] flex justify-center content-center overflow-hidden max-w-[275px] mx-auto md:mx-0">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="max-h-[600px] md:max-h-[600px] rounded"
          >
            <source
              src="https://github.com/SKCarlsson/filestorage/raw/refs/heads/main/guestgallery/landing_frame.webm"
              type="video/webm"
            />
            {t("Section2.videoError")}
          </video>
        </div>
        <div className="grid gap-10 md:gap-20">
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
            <div className="flex flex-col gap-2">
              {t.rich("6point.point4", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
            <div className="flex flex-col gap-2">
              {t.rich("6point.point5", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-primary"></div>
            <div className="flex flex-col gap-2">
              {t.rich("6point.point6", textSettings)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export function BenefitsCardChristmas() {
  const t = useTranslations("landingPages.julefrokost.6point");

  const textSettings = {
    pstrong: (children: any) => <p className="font-bold">{children}</p>,
    p: (children: any) => <p>{children}</p>,
    h2: (children: any) => <h2 className="font-bold text-lg">{children}</h2>,
  };

  return (
    <div className="w-full max-w-screen-lg lg:mx-auto place-items-center grid gap-10 md:gap-20 items-center p-4 md:p-0">
      <h2 className="font-semibold text-4xl">{t("title")}</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mx-4">
        <div className="grid gap-10 md:gap-20">
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-gg-christmas-red"></div>
            <div className="flex flex-col gap-2">
              {t.rich("point1", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-gg-christmas-red"></div>
            <div className="flex flex-col gap-2">
              {t.rich("point2", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-gg-christmas-red"></div>
            <div className="flex flex-col gap-2">
              {t.rich("point3", textSettings)}
            </div>
          </div>
        </div>
        <div className="w-full rounded-[2.6rem] flex justify-center content-center overflow-hidden max-w-[275px] mx-auto md:mx-0">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="max-h-[600px] md:max-h-[600px] rounded"
          >
            <source
              src="https://github.com/SKCarlsson/filestorage/raw/refs/heads/main/guestgallery/landing_frame.webm"
              type="video/webm"
            />
            {t("Section2.videoError")}
          </video>
        </div>
        <div className="grid gap-10 md:gap-20">
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-gg-christmas-red"></div>
            <div className="flex flex-col gap-2">
              {t.rich("point4", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-gg-christmas-red"></div>
            <div className="flex flex-col gap-2">
              {t.rich("point5", textSettings)}
            </div>
          </div>
          <div className="flex gap-2">
            <div className="w-6 h-6 min-w-6 min-h-6 rounded-full bg-gg-christmas-red"></div>
            <div className="flex flex-col gap-2">
              {t.rich("point6", textSettings)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
